<script lang="ts">
  import sizeDiv from '../sizeDiv';
  import type TonicOrNot from './tonicOrNot';

  export let interactive: TonicOrNot;
  export let tonicizing = true;
  export let playingAnswer = true;
  export let gameOver = false;

  let emptyWidthDiv: HTMLDivElement;
  let gameBoardDiv: HTMLDivElement;
  export function resize(height: number) {
    console.log('resizing');
    if (!emptyWidthDiv || !gameBoardDiv) return 0;
    return sizeDiv(emptyWidthDiv.clientWidth, height, gameBoardDiv, { noWrap: true });
  }
</script>

<div bind:this={emptyWidthDiv} />
<div bind:this={gameBoardDiv} class="gameBoardDiv">
  {#if !gameOver}
    {#if tonicizing}
      <h2>Listen to the tonicization...</h2>
    {:else}
      <h2>Is the note you hear tonic?</h2>
    {/if}
    <div class="buttonsDiv">
      <button
        class="uButton"
        disabled={playingAnswer}
        on:click={() => interactive.checkAnswer('tonic')}>Tonic</button
      >
      <button
        class="uButton"
        disabled={playingAnswer}
        on:click={() => interactive.checkAnswer('not')}>Not</button
      >
    </div>
  {:else}
    <h2>Nice Work!</h2>
  {/if}
</div>

<style>
  .gameBoardDiv {
    text-align: center;
  }

  h2 {
    font-size: 1em;
  }

  button {
    margin: 15px;
    font-size: 2em;
  }

  .buttonsDiv {
    display: grid;
    grid-template: 1fr / repeat(2, 1fr);
  }
</style>
